import PropTypes from 'prop-types';
import { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
// @mui
import { Collapse } from '@mui/material';
// hooks
import useActiveLink from '../../../hooks/useActiveLink';
//
import NavItem from './NavItem';

// ----------------------------------------------------------------------

NavList.propTypes = {
  data: PropTypes.object,
  depth: PropTypes.number,
  hasChild: PropTypes.bool,
};

export default function NavList({ data, depth, hasChild }) {
  const { pathname } = useLocation();
  const { active, isExternalLink } = useActiveLink(data.path);

  // Use the 'open' state to control the accordion
  const [open, setOpen] = useState(false);

  // Move the `handleClose` function inside the useEffect callback using `useCallback`
  const handleClose = useCallback(() => {
    setOpen(false);
  }, []); // No dependencies needed for `handleClose`

  useEffect(() => {
    if (active) {
      // Open the accordion when the item is active
      setOpen(true);
    } else {
      // Close the accordion when the item is not active
      handleClose();
    }
  }, [active, handleClose]);

  const handleToggle = () => {
    // Toggle the 'open' state when the user clicks on the accordion header
    setOpen((prevOpen) => !prevOpen);
  };

  return (
    <>
      <NavItem
        item={data}
        depth={depth}
        open={open}
        active={active}
        isExternalLink={isExternalLink}
        onClick={handleToggle} // Use handleToggle to control the 'open' state
      />

      {hasChild && (
        <Collapse in={open} unmountOnExit>
          <NavSubList data={data.children} depth={depth} />
        </Collapse>
      )}
    </>
  );
}

// ----------------------------------------------------------------------

NavSubList.propTypes = {
  data: PropTypes.array,
  depth: PropTypes.number,
};

function NavSubList({ data, depth }) {
  return (
    <>
      {data.map((list) => (
        <NavList
          key={list.title + list.path}
          data={list}
          depth={depth + 1}
          hasChild={!!list.children}
        />
      ))}
    </>
  );
}
